import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				padding: "16px 16px 0px"
			},
			header: {
				display: "flex",
				justifyContent: "space-between",
				paddingBottom: 12,
				borderBottom: `1px dashed ${theme.palette.grey[800]}`
			},
			border: {
				width: 15,
				height: 15,
				position: "absolute",
				borderRadius: "50%",
				top: 45,
				background: theme.palette.grey["A400"]
			},
			times: {
				display: "flex",
				alignItems: "center",
				color: theme.palette.primary.contrastText,
				"& > img": {
					marginRight: 5
				}
			},
			status: {
				color: theme.palette.common.white,
				padding: "5px 10px",
				fontSize: 12,
				borderRadius: 4,
				fontWeight: 500,
				backgroundColor: "red"
			}
		}),
	{
		name: "HeaderHistoryOrder",
		index: 1
	}
);

export default useStyles;
